import { getPresetPickerSubLabel } from "../../utils/passportPresetUtils";

export function getTrendingPresetSubLabel(preset, categoryDefault = "", categoryId = null) {
  return getPresetPickerSubLabel(preset, categoryId, categoryDefault);
}

/** Short label for category badge in mixed-category dropdowns. */
export function getTrendingPresetCategoryBadge(categoryName = "") {
  const normalized = String(categoryName).trim();
  if (normalized === "STANDARD") return "Standard";
  if (normalized === "Market Places") return "Marketplaces";
  if (normalized === "Socialmedia Profile Pictures") return "Profile";
  return normalized;
}
